import React from "react";

export default function FileUploader({
  type = 'segment',
  readUploadFile,
  isManual
}) {
  return (
    <div className="csv-file-cpf">
      <span>ou</span>

      <input type="file" onChange={readUploadFile} disabled={isManual} />

      <a href={type == 'segment' ? "/assets/downloads/lista-de-cpfs.csv" : '/assets/downloads/lista-de-cashback.csv'}>
        Baixar modelo do arquivo de importação.
      </a>

      <small>
        {type == 'segment' ? (
          <>
            Obs.: Necessário o envio do CPF considerando 11 dígitos: Exemplo: 00999999999 ou 009.999.999-99
          </>
        ) : (
          <>
            Obs.: Necessário o envio do CPF considerando 11 dígitos. Exemplo:
            00999999999 ou 009.999.999-99.
            <br />
            Obs²: Necessário o envio da referência considerando o formato de
            "MM/YYYY". Exemplo: 01/2023.
          </>
        )}
      </small>
    </div>
  );
}
